export default {
    relationshipRules: []
}
